import React from 'react'

const Footer = () => {
  return (
    <div className='footer__container'>
        <div className='footer__inner container grid'>
            <div className='copyrights'>
                <p>Copyright© {(new Date().getFullYear())} <a href="https://Web-crafters-hub.com/">Web Crafters Hub</a> </p>
            </div>
            <div className='developed'>
                <p>Designed & Developed by Web Crafters Hub</p>
            </div>
        </div>
    </div>
  )
}

export default Footer